import {Link} from "@amzn/awsui-components-react-v3";
import {ExternalRoutes} from "src/components/common/router-common";
import React from "react";

export const FormulaSheetExternalLink = () => {
    return (<Link external href={ExternalRoutes.smDashboardFormulaSheet}>
        Read more about formula to compute the metric
    </Link>)
}
